import { applyMiddleware, createStore, Store } from 'redux';
import rootReducer from './rootReducer';
import eventClassToObject from './middleware/eventClassToObjectMiddleware';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware } from 'redux-observable';
import rootEpic from './epics/index';
import Event from './Event';
import State from './State';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import UserAuthenticator from '../user/epic/CognitoUserAuthenticator';
import * as sessionState from './sessionState';
import eventToNavigation from './middleware/eventToNavigation';
import eventToNavigationConfig from './middleware/eventToNavigationConfig';
import eventGuard from './middleware/eventGuard';
import eventGuardConfig from './middleware/eventGuardConfig';
import eventToNotificationConfig from './middleware/eventToNotificationConfig';
import eventToNotification from './middleware/eventToNotification';
import decorateWithHeaders from './backend/decorateWithHeaders';
import { ajax } from 'rxjs/internal/observable/dom/ajax';
import getPreloadedState from './getPreloadedState';
import Backend from './backend/Backend';
import eventToSideEffect from './middleware/eventToSideEffect';
import eventToSideEffectConfig from './middleware/eventToSideEffectConfig';

export const history = createBrowserHistory();

let backend: Backend;

export const getBackend = (): Backend => backend;

export default (): Store => {
    backend = decorateWithHeaders(() => ({
        Authorization: UserAuthenticator.currentUserValue.token
    }))(ajax);
    const epicMiddleware = createEpicMiddleware<Event, Event, State>({
        dependencies: backend
    });
    const store: Store<State> = createStore(
        rootReducer(history),
        getPreloadedState(),
        composeWithDevTools(
            applyMiddleware(
                eventGuard(eventGuardConfig),
                eventToSideEffect(eventToSideEffectConfig),
                eventToNotification(eventToNotificationConfig),
                eventClassToObject,
                eventToNavigation(eventToNavigationConfig),
                epicMiddleware,
                routerMiddleware(history)
            )
        )
    );
    store.subscribe(() => sessionState.set(store.getState()));
    epicMiddleware.run(rootEpic);
    return store;
};



// WEBPACK FOOTER //
// ./src/application/core/createStore.ts